import React from 'react'
import "./WorkComponent.css"

const WorkComponent = () => {
  return (
    <section className="troo-da-how-we-works-section" id="troo-da-how-we-works-section">
    <div className="container">
      <div className="row">
        <div className="col-md-7">
          <div className="how-we-works-text">
            <div className="troo-tile">
              <span>3 Easy steps we follow</span>
              <h2>See how we works</h2>
            </div>
          </div>
        </div>
        <div className="col-md-5">
          <div className="how-we-txt">
            <p>It is a long established fact that it is also reader we arewill be distracted by the readable.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default WorkComponent